// @flow

import React, { type Node } from 'react';

import { useSubmitError } from '@tectonics/prs/validation';
import { type PlaceOrderErrorPayload } from '@tectonics/prs/outgoing-payment';
import { useIncomingPayment, getCountry } from '@tectonics/prs/incoming-payment';

import { Empty } from '../../../commons/atoms';
import { ErrorDisplay } from '../../../commons/molecules';

export function SubmitErrorDisplay(): Node {
  const submitError: ?PlaceOrderErrorPayload = useSubmitError();
  const country = getCountry(useIncomingPayment());

  if (!submitError) {
    return <Empty />;
  }

  const { code, message: serverMessage } = submitError;

  const customMessage = country === 'br' ? getBrazilianCustomMessage(code) : getSpanishCustomMessage(code);

  return <ErrorDisplay>{customMessage || serverMessage}</ErrorDisplay>;
}

function getBrazilianCustomMessage(code: string): ?string {
  return {
    'BP-DR-18':
      'Encontramos um problema com o seu cadastro. Entre em contato com o suporte Uber em https://help.uber.com/pt-BR/riders para maiores informações',
    'BP-DR-39':
      'Houve um problema com o CPF informado. Para maiores detalhes, entre em contato com o suporte Uber em https://help.uber.com/pt-BR/riders.',
    'BP-DR-84':
      'Há uma solicitação de pagamento aberta ou efetuada recentemente sob seu cadastro. Por favor, tente novamente em alguns minutos.',
    'BP-DR-90':
      'Encontramos um problema com o seu cadastro. Entre em contato com o suporte Uber em https://help.uber.com/pt-BR/riders para maiores informações',
  }[code];
}

function getSpanishCustomMessage(code: string): ?string {}
